/** Map MIS treatment plan detail → diagnostics compose seed payload. */

export type MisPlanDetailForCorrection = {
  plan_id: string
  notes?: string | null
  metadata?: Record<string, unknown> | null
  stages?: Array<{
    stage_type?: string | null
    clinical_objective?: string | null
    clinical_note?: string | null
    expected_visit_count?: number | null
    items?: Array<{
      item_id?: string
      snapshot_id?: string
      display_name?: string | null
      quantity?: number | null
      expected_cost_minor?: number | null
      clinical_note?: string | null
      dental_scope?: { teeth?: unknown[] } | null
      metadata?: Record<string, unknown> | null
    }>
  }>
}

export function buildSeedPayloadFromMisPlan(
  plan: MisPlanDetailForCorrection,
  staffUserId: string,
): Record<string, unknown> {
  const stages = (plan.stages ?? [])
    .map((stage) => {
      const items = (stage.items ?? [])
        .map((item) => {
          const snapshotId = String(item.snapshot_id ?? '').trim()
          if (!snapshotId) return null
          const teeth = Array.isArray(item.dental_scope?.teeth)
            ? item.dental_scope!.teeth!.map(String)
            : []
          return {
            snapshot_id: snapshotId,
            display_name: item.display_name?.trim() || undefined,
            quantity: item.quantity && item.quantity > 0 ? item.quantity : 1,
            expected_cost_minor:
              typeof item.expected_cost_minor === 'number' && item.expected_cost_minor > 0
                ? item.expected_cost_minor
                : undefined,
            dental_scope: { teeth },
            clinical_note: item.clinical_note?.trim() || undefined,
            metadata: {
              ...(item.metadata ?? {}),
              diagnostics_compose: true,
              source_mis_plan_id: plan.plan_id,
            },
          }
        })
        .filter(Boolean)
      if (items.length === 0) return null
      return {
        stage_type: stage.stage_type?.trim() || 'therapeutic',
        clinical_objective: stage.clinical_objective?.trim() || 'Корректировка плана лечения',
        expected_visit_count: stage.expected_visit_count ?? 1,
        clinical_note: stage.clinical_note?.trim() || null,
        items,
      }
    })
    .filter(Boolean)

  return {
    authoring_clinician_id: staffUserId,
    notes: plan.notes?.trim() || 'Корректировка ИИ-плана из «Планы МИС пациента»',
    stages,
    metadata: {
      diagnostics_compose: true,
      mis_plan_correction: true,
      source_mis_plan_id: plan.plan_id,
      ...(plan.metadata ?? {}),
    },
  }
}
